var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CustomScroll",
    { ref: "outerContainer", staticClass: "flex-1 h-full pr-2" },
    [
      _c(
        "div",
        { staticClass: "h-full flex flex-col justify-start padMobile sm:pt-8" },
        [
          _c(
            "div",
            { staticClass: "messages flex flex-col-reverse" },
            _vm._l(_vm.messages, function (message, index) {
              return _c(
                "div",
                { key: message.id, staticClass: "flex flex-col" },
                [
                  _vm.showDateSeparation({
                    index,
                    message,
                    messages: _vm.messages,
                  })
                    ? _c("MessageSeparatorByDate", {
                        attrs: { message: message },
                      })
                    : _vm._e(),
                  _c("InboxMessage", {
                    staticClass: "mb-3 px-3",
                    attrs: {
                      data: message,
                      isGroupConversation: _vm.isGroupConversation,
                      currentUserId: _vm.currentUserId,
                      uploadingAttachmentId: _vm.uploadingAttachmentId,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
          _vm.noParticipants
            ? _c(
                "div",
                {
                  staticClass:
                    "w-full flex px-3 flex-col justify-center items-center font-semibold text-lg pb-12 mt-6 mb-12",
                },
                [
                  _c("span", { staticClass: "block" }, [
                    _vm._v("Looks like this conversation is over."),
                  ]),
                  _c("span", [_vm._v("You are the last participant.")]),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }